import React from "react";
import DevImage from "../../assets/images/BLOCHALANGE2.jpg";
import DevPImage from "../../assets/images/banner.jpeg";
import CnfImage from "../../assets/images/BLOCHALANGE-4.jpg";
import {useNavigate} from "react-router-dom"
import { routes } from "../../routes";

const Formation = () => {
  const navigate = useNavigate()
  const applyNow = ()=>{
    navigate(routes.application.application)
  }
  return (
    <div className="formation_container">
      <div className="banner_container">
        <div className="box_container">
          <div className="banner">
            <h2>Nos parcours</h2>
          </div>
        </div>
      </div>
      <div className="formation_wraper">
        <div className="box_container">
          <div className="formation_grid">
            <div className="formation_card">
              <div className="formation_card_image">
                <img src={DevImage} alt="dev_web_mobile" />
                <span className="formation_card_badge">12 mois</span>
              </div>
              <div className="formation_card_content">
                <h6 className="formation_card_title">
                  Développeur web et mobile
                </h6>
                <p className="formation_card_description">
                  Devenez Développeur web front-end, Développeur web full-stack
                  ou Développeur web et mobile avancé. Apprenez à coder avec les
                  technologies les plus recherchées sur le marché : HTML, CSS,
                  JavaScript, React, Vuejs, Node.js, PHP, Laravel, Flutter.
                </p>
                <div className="formation_card_cta">
                  <button className="cta_btn" onClick={applyNow}>Postuler</button>
                  <div className="more_btn">
                    <a href="https://ecole229.bj" target="_blank" rel="noreferrer">En savoir plus</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="formation_card">
              <div className="formation_card_image">
                <img src={CnfImage} alt="dev_web_mobile" />
                <span className="formation_card_badge">6 mois</span>
              </div>
              <div className="formation_card_content">
                <h6 className="formation_card_title">
                  Compétences Numériques Fondamentales{" "}
                </h6>
                <p className="formation_card_description">
                  Le Parcours « Compétences Numériques Fondamentales » a été
                  mise en place pour répondre aux besoins croissants en matière
                  de compétences numériques de base. Ce parcours vise à donner
                  aux jeunes passionnés des compétences numériques
                  indispensables à la vie quotidienne, tant sur le plan
                  personnel que professionnel. Il est destiné à aider les
                  individus vulnérables à acquérir les compétences nécessaires
                  pour être capables de naviguer dans l’environnement numérique,
                  d’utiliser les technologies de l’information et de la
                  communication (TIC) de manière efficace et responsable, de
                  maintenir une présence en ligne sûre et sécurisée et de
                  faciliter leur insertion professionnelle.
                </p>
                <div className="formation_card_cta">
                  <button className="cta_btn" onClick={applyNow}>Postuler</button>
                  <div className="more_btn">
                    <a href="https://ecole229.bj" target="_blank" rel="noreferrer">En savoir plus</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="formation_card">
              <div className="formation_card_image">
                <img src={DevPImage} alt="dev_web_mobile" />
                <span className="formation_card_badge">6 mois</span>
              </div>
              <div className="formation_card_content">
                <h6 className="formation_card_title">Développeur web - Parakou</h6>
                <p className="formation_card_description">
                  Devenez Développeur web front-end, Développeur web full-stack
                  ou Développeur web et mobile avancé. Apprenez à coder avec les
                  technologies les plus recherchées sur le marché : HTML, CSS,
                  JavaScript, React, Vuejs, Node.js, PHP, Laravel, Flutter.
                </p>
                <div className="formation_card_cta">
                  <button className="cta_btn" onClick={applyNow}>Postuler</button>
                  <div className="more_btn">
                    <a href="https://ecole229.bj" target="_blank" rel="noreferrer">
                      En savoir plus
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Formation;
